import React from "react";
import { UIFlightData } from "@flights/types";
import useFareRulesStatusInfoController from "./FareRulesStatusInfo.controller";
import { Icon, Stack } from "@bookingcom/bui-react";
import { PlaneTicketReturnIcon } from "@bookingcom/bui-assets-react/streamline";
import { Trans } from "@bookingcom/lingojs-react";
import useRouteName from "../../../../../../../hooks/useRouteName";
import useProfiler from "../../../../../../../hooks/useProfiler";
import flights_web_condensed_extras_fd_mdot from "../../../../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

const useFareRulesStatusInfo = (flight: UIFlightData) => {
  const { header, fareRulesContent } = useFareRulesStatusInfoController(flight);

  const routeName = useRouteName();
  const { isMobile } = useProfiler();
  const condensedFDMobile =
    routeName == "flightdetails" && isMobile() && !!flights_web_condensed_extras_fd_mdot.trackWithDefaultStage();

  if (!fareRulesContent) return undefined;

  return {
    header,
    content: (
      <Stack direction="row" gap={4}>
        <div>
          <Icon svg={PlaneTicketReturnIcon} size={condensedFDMobile ? "medium" : "larger"} />
        </div>
        <Stack.Item grow={true}>
          <Trans
            tag={fareRulesContent.copyTag}
            components={[<strong key={0} />]}
            variables={{ airline: fareRulesContent.carrierName, start_bold: "<0>", end_bold: "</0>" }}
          />
        </Stack.Item>
      </Stack>
    )
  };
};

export default useFareRulesStatusInfo;
